import React from 'react';

import useReports from 'hooks/useReports';

import ReportViewMenu from 'components/templates/menus/ReportViewMenu';

import ReportDisplay from './ReportDisplay';
import ReportViewportArea from './ReportViewportArea';
import { ListingStack } from './reportsViewStyles';

export default function HomePage() {
  const { reports } = useReports();

  const reportId = React.useMemo(
    () => reports?.data?.filter((x) => x.group === 'Home')?.[0]?.id,
    [reports],
  );

  return (
    <ListingStack>
      <ReportViewMenu />
      <ReportViewportArea>
        {!!reportId && <ReportDisplay reportId={reportId} />}
      </ReportViewportArea>
    </ListingStack>
  );
}
